import moment from 'moment'

const wordLimit = (word = '', num = 0) => {
  if (!word) return
  let str = ''
  if (word.length > num) {
    str = word.substring(0, num) + '...'
  } else {
    str = word
  }
  return str
}

const dateFormat = (time = '', format = '') => {
  if (!time) return ''
  let ss = ''
  if (format === 'MM-dd') {
    ss = moment(time).format('MM-DD')
  } else if (format === 'yyyy') {
    ss = moment(time).format('YYYY')
  } else if (format === 'yyyy-MM-dd') {
    ss = moment(time).format('YYYY-MM-DD')
  }
  return ss
}

export {
  wordLimit,
  dateFormat
}
